import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"
import EmptyScreen from "@images/empty/screen_empty.svg"
import { word } from "@modules/core/utils/i18n"

export type PayoutEmptyViewProps = {} & React.HTMLAttributes<HTMLDivElement>

export const PayoutEmptyView: React.FC<PayoutEmptyViewProps> = (props) => {
  const theme = useTheme()

  return (
    <div
      className="flex gap-5 p-8 align-items-center	justify-content-center w-full  bg-neutralColor-50 border-round-3xl"
      {...props}
    >
      <div className="flex flex-column gap-1 pl-6">
        <HUText fontStyle="HL" color={theme.blackAtheleWhiteOwner} className="flex">
          {word("finances.payoutEmpty.header")}
        </HUText>
        <HUText fontStyle="BL" color={theme.blackAtheleWhiteOwner} className="flex">
          {word("finances.payoutEmpty.subHeader")}
        </HUText>
      </div>
      <div className="flex pr-6">
        <div
          className=" bg-neutralColor-100 border-round-3xl bg-contain bg-no-repeat bg-center"
          style={{ width: "343px", height: "318px", backgroundImage: `url('${EmptyScreen} ')` }}
        ></div>
      </div>
    </div>
  )
}
